import { useTheme } from '@emotion/react';
import DoneIcon from '@mui/icons-material/Done';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineItem,
  TimelineSeparator,
} from '@mui/lab';
import {
  Badge,
  Box,
  Card,
  Grid,
  IconButton,
  MenuItem,
  Popover,
  Typography,
  useMediaQuery,
} from '@mui/material';
import {
  buyerDashboardActivity,
  dashboardActivity,
  getApiCall,
  vendorDashboardActivity,
} from 'api/apiService';
import { ReactComponent as Eye } from 'assets/icons/eye.svg';
import { ToggleOff } from 'component/ContactTab/ContactTab';
import { ToggleOn } from 'component/OwnerCard/OwnerCard';
import { datacontext } from 'modules/AppLayout/AppLayout';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { poppins300 } from 'theme/common.style';
import {
  activityCont,
  circleCont,
  displayFlex,
  displayFlexRow,
} from './ActivityContainer.style';
import {
  Campaignicon,
  Contractmanagement,
  Depositicon,
  Duediligence,
  Inspectionicon,
  Offericon,
  Personalprofileicon,
  Request66w,
  Solicitoricon,
} from './ActivityIcons';
import { handleactivitylink } from './Activitylink';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import ActivityCard from 'component/Common/ActivityCard';
import {
  Calendarimg,
  Filter,
  FilterColor,
} from 'assets/svgfunctions/commonsvg';
import { Loadingfunc } from 'component/MessagingContainer/MessagingContainer';

function ActivityContainer({ individual, ActivityTitle, activityupdate }) {
  const data = localStorage.getItem('userDetail');
  const primaryUserTypeValue = JSON.parse(localStorage.getItem('primaryUser'));
  const [activitydata, setActivitydata] = useState([]);
  const [activitydataValidate, setActivitydataValidate] = useState('');
  const [offersOnly, setOffersOnly] = useState(false);
  const [loading, setLoading] = useState(true);
  const {
    realTimeLog,
    solicitorupdate,
    setSelectedBuyerid,
    setOpenbuyercard,
    setShowMessage,
    setMessagedata,
  } = useContext(datacontext);
  const params = useParams();
  const propertyId = params?.dashboardId;
  const [offerOnlyData, setOfferOnlyData] = useState([]);
  const [offerValidate, setOfferValidate] = useState('');
  const [openBox, setOpenBox] = useState(false);
  const [isHovered, setIsHovered] = useState(true);
  const [isaudiocompleted, setIsaudiocompleted] = useState(false);
  const [style, setStyle] = useState(false);
  const [indexValue, setIndexValue] = useState('');
  const [activityAnimation, setActivityAnimation] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const spanRef = React.useRef();
  function handleClick() {
    setAnchorEl(spanRef.current);
    setOpenBox(true);
  }
  const audiofile =
    JSON.parse(localStorage.getItem('audiofiles') || '{}')?.UrgentPop ?? '';

  useEffect(() => {
    if (primaryUserTypeValue == 'Vendor') {
      offersOnlyApi();
    }
  }, [realTimeLog, propertyId]);

  useEffect(() => {
    const askPermission = async () => {
      await Notification.requestPermission(); // This counts as user interaction

      if (offerOnlyData?.length > 0 && offerOnlyData[0]?.vendorStatus == null) {
        const audioplayer = new Audio(audiofile);
        audioplayer.play().catch((e) => console.error('play failed', e));
      }
    };

    askPermission();
  }, [offerOnlyData]);

  const offersOnlyApi = () => {
    setLoading(true);
    getApiCall(`vendor/offerActivity/${propertyId}`).then((res) => {
      setIsaudiocompleted(false);
      setIsHovered(true);
      if (res?.data?.status == 1) {
        setOfferOnlyData((res?.data?.offerActivity).reverse());
        setOfferValidate('');
      } else {
        setOfferValidate('No Offers Found');
      }
      setLoading(false);
    });
  };

  const styleFunc = (lengthData, index) => {
    if (offerOnlyData[0]?.vendorStatus == null && isHovered && index == 0) {
      return {
        animation: 'blink 0.7s 6',
        opacity: 1,
        border: '2px solid #6C2AD2',
      };
    }
  };

  useEffect(() => {
    if (primaryUserTypeValue == 'Vendor' && individual) {
      setOffersOnly(true);
    }
  }, [propertyId]);

  dayjs.extend(utc);
  dayjs.extend(timezone);

  function timeAgo(timestamp) {
    const pastDate = dayjs(timestamp).tz('Australia/Sydney', true);
    const nowSydney = dayjs().tz('Australia/Sydney');
    const diffInMs = nowSydney.diff(pastDate); // Difference in milliseconds
    if (diffInMs < 0) {
      return 'Just now'; // Prevents negative values
    }

    const diffInSeconds = Math.floor(diffInMs / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInSeconds < 60) {
      return `${diffInSeconds} second${diffInSeconds !== 1 ? 's' : ''} ago`;
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes} minute${diffInMinutes !== 1 ? 's' : ''} ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hour${diffInHours !== 1 ? 's' : ''} ago`;
    } else {
      return `${diffInDays} day${diffInDays !== 1 ? 's' : ''} ago`;
    }
  }

  const styleMenu = {
    fontFamily: 'Poppins!important',
    fontWeight: 400,
    fontSize: '14px',
    color: '#000000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  };
  const [arrayType, setArrayType] = useState([]);

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const activityAPI = () => {
    setLoading(true);
    const input = {
      propertyId: !individual ? 0 : params?.dashboardId,
      activityType: 'Default',
    };

    if (primaryUserTypeValue == 'Agent') {
      dashboardActivity(input).then((resp) => {
        if (resp?.status === 1) {
          setActivitydata(resp?.activities);
          setActivitydataValidate('');
        } else {
          setActivitydataValidate('Activity not found');
        }
        setLoading(false);
      });
    } else if (primaryUserTypeValue == 'Vendor') {
      vendorDashboardActivity(input).then((resp) => {
        if (resp?.status === 1) {
          setActivitydata(resp?.activities);
          setActivitydataValidate('');
        } else {
          setActivitydataValidate('Activity not found');
        }
        setLoading(false);
      });
    } else if (primaryUserTypeValue == 'Buyer') {
      buyerDashboardActivity(input).then((resp) => {
        if (resp?.status === 1) {
          setActivitydata(resp?.activities);
          setActivitydataValidate('');
        } else {
          setActivitydataValidate('Activity not found');
        }
        setLoading(false);
      });
    }
  };

  useEffect(() => {
    if (!activityAnimation) {
      activityAPI();
    }
  }, [activityupdate, realTimeLog, solicitorupdate]);
  useEffect(() => {
    activityAPI();
  }, [realTimeLog, propertyId]);
  let typeArr = arrayType;

  function addItem(item) {
    const index = typeArr.indexOf(item);
    if (index !== -1) {
      // If the item already exists, remove it
      typeArr.splice(index, 1);
    } else {
      // If the item doesn't exist, add it
      typeArr.push(item);
    }
    // Add the item
    return typeArr;
  }
  let array;
  const [allStatus, setAllStatus] = useState(true);

  const getData = (menuValue) => {
    var mounted = true;
    array = addItem(menuValue);
    setArrayType(array);

    setAllStatus(menuValue == 'Default' ? true : false);

    const result =
      menuValue == 'Default'
        ? setArrayType([])
        : array.toString().split(',,').join(',');
    let showValue;
    if (array.length == 1 && menuValue != 'All') {
      showValue = array[0];
    }
    const input = {
      propertyId: !individual ? 0 : params?.dashboardId,
      activityType: menuValue == 'Default' ? 'Default' : result,
    };

    dashboardActivity(input).then((resp) => {
      if (resp?.status === 1) {
        if (mounted) {
          if (resp?.status === 1) {
            setActivitydataValidate('');
            setActivitydata(resp?.activities);
          }
        }
      } else {
        if (showValue !== undefined && showValue !== 'Default') {
          setActivitydataValidate(`${showValue} activity not found`);
        } else {
          setActivitydataValidate('Activity not found');
        }
        setActivitydata([]);
      }
    });
    return () => (mounted = false);
  };

  const getDataDashVendor = (menuValue) => {
    var mounted = true;
    array = addItem(menuValue);
    setArrayType(array);

    setAllStatus(menuValue == 'Default' ? true : false);

    const result =
      menuValue == 'Default'
        ? setArrayType([])
        : array.toString().split(',,').join(',');
    let showValue;
    if (array.length == 1 && menuValue != 'All') {
      showValue = array[0];
    }

    const input = {
      propertyId: !individual ? 0 : params?.dashboardId,
      activityType: menuValue == 'Default' ? 'Default' : result,
    };

    vendorDashboardActivity(input).then((resp) => {
      if (mounted) {
        if (resp?.status === 1) {
          setActivitydataValidate('');
          setActivitydata(resp?.activities);
        } else {
          if (showValue !== undefined && showValue !== 'Default') {
            setActivitydataValidate(`${showValue} activity not found`);
          } else {
            setActivitydataValidate('Activity not found');
          }
          setActivitydata([]);
        }
      }
    });
    return () => (mounted = false);
  };

  const getDataDashBuyer = (menuValue) => {
    var mounted = true;
    array = addItem(menuValue);
    setArrayType(array);

    setAllStatus(menuValue == 'Default' ? true : false);

    const result =
      menuValue == 'Default'
        ? setArrayType([])
        : array.toString().split(',,').join(',');
    let showValue;
    if (array.length == 1 && menuValue != 'All') {
      showValue = array[0];
    }

    const input = {
      propertyId: 0,
      activityType: menuValue == 'Default' ? 'Default' : result,
    };

    buyerDashboardActivity(input).then((resp) => {
      if (mounted) {
        if (resp?.status === 1) {
          setActivitydataValidate('');
          setActivitydata(resp?.activities);
        } else {
          if (showValue !== undefined && showValue !== 'Default') {
            setActivitydataValidate(`${showValue} activity not found`);
          } else {
            setActivitydataValidate('Activity not found');
          }
          setActivitydata([]);
        }
      }
    });
    return () => (mounted = false);
  };

  useEffect(() => {
    if (primaryUserTypeValue === 'Vendor') {
      const input = {
        propertyId: !individual ? 0 : params?.dashboardId,
        activityType: 'Default',
      };
      vendorDashboardActivity(input).then((resp) => {
        if (resp?.status === 1) {
          setActivitydata(resp?.activities);
        }
      });
    }
  }, [realTimeLog]);

  const theme = useTheme();
  const history = useHistory();

  const onPropertyClick = async (propertyId, title, binderid, userId) => {
    await handleactivitylink(
      propertyId,
      title,
      history,
      primaryUserTypeValue,
      binderid,
      setSelectedBuyerid,
      userId,
      setOpenbuyercard,
      setShowMessage,
      setMessagedata
    );
  };

  const handleMenuItemClick = (value) => {
    if (primaryUserTypeValue == 'Agent') {
      getData(value);
    } else if (primaryUserTypeValue == 'Vendor') {
      getDataDashVendor(value);
    } else if (primaryUserTypeValue == 'Buyer') {
      getDataDashBuyer(value);
    }
  };

  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Card
      variant="outlined"
      sx={{ ...activityCont, borderRadius: matchessm ? '10px' : '5px' }}
    >
      <Typography sx={displayFlex}>
        {!ActivityTitle && (
          <Box
            sx={{
              position: 'sticky',
              top: 0,
              backgroundColor: '#fff',
            }}
          >
            <Grid
              container
              sx={{
                height: '38px',
                borderRadius: '5px',
                border: '0.5px solid #E4E4E4',
                backgroundColor: '#BCBBBC1A',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Grid item paddingTop={'6px'}>
                <Typography
                  sx={{
                    fontFamily: 'Poppins!important',
                    fontWeight: 500,
                    fontSize: '14px',
                    color: '#26344E',

                    paddingLeft: '8px',
                  }}
                >
                  Activity
                </Typography>
              </Grid>
              <Grid
                item
                paddingTop={'4px'}
                paddingRight={'4px'}
                style={{ cursor: 'pointer' }}
              >
                <Typography
                  ref={spanRef}
                  aria-describedby={id}
                  variant="contained"
                  onClick={handleClick}
                >
                  {openBox ? (
                    <Badge badgeContent={arrayType?.length} color="error">
                      <FilterColor />
                    </Badge>
                  ) : (
                    <Badge badgeContent={arrayType?.length} color="error">
                      <Filter />
                    </Badge>
                  )}
                </Typography>
                <Popover
                  onClose={() => setOpenBox(false)}
                  sx={{ position: 'fixed', top: '22px', left: '-9px' }}
                  id={id}
                  open={openBox}
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                >
                  <MenuItem
                    value={20}
                    onClick={() => handleMenuItemClick('Default')}
                  >
                    <Typography sx={styleMenu}>
                      All &nbsp;
                      {arrayType?.length == 0 && (
                        <IconButton sx={{ padding: 0, marginLeft: '10px' }}>
                          <DoneIcon />
                        </IconButton>
                      )}
                    </Typography>
                  </MenuItem>
                  <MenuItem
                    value={30}
                    onClick={() => handleMenuItemClick('Offers')}
                  >
                    <Typography sx={styleMenu}>
                      Offers &nbsp;
                      {
                        <IconButton
                          sx={{
                            visibility: arrayType?.includes('Offers')
                              ? 'visible'
                              : 'hidden',
                            padding: 0,
                            marginLeft: '10px',
                          }}
                        >
                          <DoneIcon />
                        </IconButton>
                      }
                    </Typography>
                  </MenuItem>
                  {primaryUserTypeValue == 'Buyer' ? (
                    <MenuItem
                      value={33}
                      onClick={() => handleMenuItemClick('Checklist')}
                    >
                      <Typography sx={styleMenu}>
                        Checklist
                        {
                          <IconButton
                            sx={{
                              visibility: arrayType?.includes('Checklist')
                                ? 'visible'
                                : 'hidden',
                              padding: 0,
                              marginLeft: '10px',
                            }}
                          >
                            <DoneIcon />
                          </IconButton>
                        }
                      </Typography>
                    </MenuItem>
                  ) : (
                    <MenuItem
                      value={33}
                      onClick={() => handleMenuItemClick('Buyer')}
                    >
                      <Typography sx={styleMenu}>
                        Buyer
                        {
                          <IconButton
                            sx={{
                              visibility: arrayType?.includes('Buyer')
                                ? 'visible'
                                : 'hidden',
                              padding: 0,
                              marginLeft: '10px',
                            }}
                          >
                            <DoneIcon />
                          </IconButton>
                        }
                      </Typography>
                    </MenuItem>
                  )}
                  {primaryUserTypeValue == 'Buyer' ? (
                    <MenuItem
                      value={40}
                      onClick={() => handleMenuItemClick('Watching')}
                    >
                      <Typography sx={styleMenu}>
                        Watching
                        {
                          <IconButton
                            sx={{
                              visibility: arrayType?.includes('Watching')
                                ? 'visible'
                                : 'hidden',
                              padding: 0,
                              marginLeft: '10px',
                            }}
                          >
                            <DoneIcon />
                          </IconButton>
                        }
                      </Typography>
                    </MenuItem>
                  ) : (
                    <MenuItem
                      value={40}
                      onClick={() => handleMenuItemClick('Vendor')}
                    >
                      <Typography sx={styleMenu}>
                        Vendor
                        {
                          <IconButton
                            sx={{
                              visibility: arrayType?.includes('Vendor')
                                ? 'visible'
                                : 'hidden',
                              padding: 0,
                              marginLeft: '10px',
                            }}
                          >
                            <DoneIcon />
                          </IconButton>
                        }
                      </Typography>
                    </MenuItem>
                  )}
                  {!individual && primaryUserTypeValue == 'Agent' && (
                    <MenuItem
                      value={50}
                      onClick={() => handleMenuItemClick('StageOne')}
                    >
                      <Typography sx={styleMenu}>
                        Published (stage 1) &nbsp;
                        {
                          <IconButton
                            sx={{
                              visibility: arrayType?.includes('StageOne')
                                ? 'visible'
                                : 'hidden',
                              padding: 0,
                              marginLeft: '10px',
                            }}
                          >
                            <DoneIcon />
                          </IconButton>
                        }
                      </Typography>
                    </MenuItem>
                  )}
                  {primaryUserTypeValue == 'Vendor' && (
                    <MenuItem
                      value={50}
                      onClick={() => handleMenuItemClick('StageOne')}
                    >
                      <Typography sx={styleMenu}>
                        Published (stage 1) &nbsp;
                        {
                          <IconButton
                            sx={{
                              visibility: arrayType?.includes('StageOne')
                                ? 'visible'
                                : 'hidden',
                              padding: 0,
                              marginLeft: '10px',
                            }}
                          >
                            <DoneIcon />
                          </IconButton>
                        }
                      </Typography>
                    </MenuItem>
                  )}
                  {!individual && primaryUserTypeValue == 'Agent' && (
                    <MenuItem
                      value={60}
                      onClick={() => handleMenuItemClick('Unpublished')}
                    >
                      <Typography sx={styleMenu}>
                        Unpublished &nbsp;
                        {
                          <IconButton
                            sx={{
                              visibility: arrayType?.includes('Unpublished')
                                ? 'visible'
                                : 'hidden',
                              padding: 0,
                              marginLeft: '10px',
                            }}
                          >
                            <DoneIcon />
                          </IconButton>
                        }
                      </Typography>
                    </MenuItem>
                  )}
                  <MenuItem
                    value={60}
                    onClick={() => handleMenuItemClick('StageTwo')}
                  >
                    <Typography sx={styleMenu}>
                      Stage 2 only &nbsp;
                      {
                        <IconButton
                          sx={{
                            visibility: arrayType?.includes('StageTwo')
                              ? 'visible'
                              : 'hidden',
                            padding: 0,
                            marginLeft: '10px',
                          }}
                        >
                          <DoneIcon />
                        </IconButton>
                      }
                    </Typography>
                  </MenuItem>
                  {primaryUserTypeValue != 'Vendor' &&
                    primaryUserTypeValue != 'Buyer' && (
                      <MenuItem
                        value={60}
                        onClick={() => handleMenuItemClick('Ended')}
                      >
                        <Typography sx={styleMenu}>
                          Ended
                          {
                            <IconButton
                              sx={{
                                visibility: arrayType?.includes('Ended')
                                  ? 'visible'
                                  : 'hidden',
                                padding: 0,
                                marginLeft: '10px',
                              }}
                            >
                              <DoneIcon />
                            </IconButton>
                          }
                        </Typography>
                      </MenuItem>
                    )}
                  {primaryUserTypeValue == 'Buyer' && (
                    <MenuItem
                      value={60}
                      onClick={() => handleMenuItemClick('Interested')}
                    >
                      <Typography sx={styleMenu}>
                        Interested
                        {
                          <IconButton
                            sx={{
                              visibility: arrayType?.includes('Interested')
                                ? 'visible'
                                : 'hidden',
                              padding: 0,
                              marginLeft: '10px',
                            }}
                          >
                            <DoneIcon />
                          </IconButton>
                        }
                      </Typography>
                    </MenuItem>
                  )}
                  {!individual && primaryUserTypeValue == 'Agent' && (
                    <MenuItem
                      value={60}
                      onClick={() => handleMenuItemClick('Sold')}
                    >
                      <Typography sx={styleMenu}>
                        Sold &nbsp;
                        {
                          <IconButton
                            sx={{
                              visibility: arrayType?.includes('Sold')
                                ? 'visible'
                                : 'hidden',
                              padding: 0,
                              marginLeft: '10px',
                            }}
                          >
                            <DoneIcon />
                          </IconButton>
                        }
                      </Typography>
                    </MenuItem>
                  )}
                </Popover>
              </Grid>
            </Grid>
          </Box>
        )}
      </Typography>

      <Typography sx={displayFlex}>
        {ActivityTitle && (
          <Grid
            container
            sx={{
              padding: '3px 5px',
              borderRadius: '5px',
              border: '0.5px solid #E4E4E4',
              backgroundColor: '#BCBBBC1A',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Grid>
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 500,
                  fontSize: '14px',
                  color: '#26344E',
                  paddingLeft: '8px',
                }}
              >
                Live Activity
              </Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontSize: '14px',
                  color: '#26344E',
                }}
              >
                Offers Only
              </Typography>
              <IconButton onClick={() => setOffersOnly(!offersOnly)}>
                {!offersOnly ? <ToggleOff /> : <ToggleOn />}
              </IconButton>
            </Grid>
          </Grid>
        )}
      </Typography>

      <Typography sx={displayFlex}>
        <Box
          sx={{
            overflowY: 'auto',
            maxHeight: '100%',
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
          }}
        >
          {primaryUserTypeValue == 'Vendor' &&
            offersOnly &&
            !offerOnlyData?.length &&
            individual && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                  width: '100%',
                  paddingY: '50px',
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                  }}
                >
                  Activity not found
                </Typography>
              </Box>
            )}
          {loading ? (
            <Loadingfunc />
          ) : activitydataValidate != '' && !offersOnly ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                width: '100%',
                paddingY: '50px',
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'poppins',
                }}
              >
                {activitydataValidate}
              </Typography>
            </Box>
          ) : (
            <Grid sx={[displayFlexRow, { paddingTop: '20px' }]}>
              {primaryUserTypeValue == 'Vendor' &&
                offersOnly &&
                offerOnlyData?.length > 0 &&
                individual && (
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px',
                      pointerEvents: 'none',
                    }}
                  >
                    {offerValidate != '' ? (
                      <Typography
                        sx={{
                          fontFamily: 'poppins',
                          fontSize: '16px',
                          padding: '15px 0px',
                          marginTop: '8px',
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        {offerValidate}
                      </Typography>
                    ) : (
                      offerOnlyData?.map((item, index) => {
                        const timeAgoText = timeAgo(item?.createdAt);
                        const lengthData = offerOnlyData?.length;

                        if (
                          offerOnlyData?.length > 0 &&
                          offerOnlyData[0]?.vendorStatus == null &&
                          isHovered &&
                          index == 0 &&
                          !isaudiocompleted
                        ) {
                          const timer = async () => {
                            setTimeout(() => {
                              setIsHovered(false);
                            }, 7500);
                            return () => {
                              clearTimeout(timer);
                            };
                          };
                          timer();
                        }
                        return (
                          <Box
                            onMouseEnter={() => {
                              setStyle(true);
                              setIndexValue(index);
                            }}
                            onMouseLeave={() => {
                              setStyle(false);
                              setIndexValue('');
                            }}
                            style={styleFunc(lengthData, index)}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              cursor: 'pointer',
                              padding: '20px',
                              borderRadius: '5px',
                              border: `2px solid ${
                                style && indexValue == index
                                  ? '#6C2AD2'
                                  : 'white'
                              }`,
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: '20px',
                                  fontFamily: 'poppins',
                                  fontWeight: 600,
                                  overflow: 'hidden',
                                  maxWidth: '200px',
                                  textOverflow: 'ellipsis',
                                }}
                              >
                                {item?.buyerName}{' '}
                                {item?.buyerSurName?.charAt(0).toUpperCase()}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: '14px',
                                  fontFamily: 'poppins',
                                  fontWeight: 400,
                                  color: '#666666',
                                }}
                              >
                                {timeAgoText}
                              </Typography>
                            </Box>
                            <Box>
                              <Typography
                                sx={{
                                  fontSize: '20px',
                                  fontFamily: 'poppins',
                                  fontWeight: 500,
                                  color:
                                    style && indexValue == index
                                      ? '#6C2AD2'
                                      : 'black',
                                }}
                              >
                                {item?.offerPrice}
                              </Typography>
                            </Box>
                          </Box>
                        );
                      })
                    )}
                  </Box>
                )}

              {!offersOnly && (
                <Timeline
                  sx={{
                    p: 0,
                    m: 0,
                    maxWidth: '100%',
                    [`& .MuiTimelineItem-root:before`]: {
                      flex: 0,
                      padding: 0,
                    },
                  }}
                >
                  {individual
                    ? activitydata?.length > 0
                      ? activitydata.map((index, i, arr) => {
                          const isNewCategory =
                            i === 0 ||
                            index.activityCatogory !==
                              arr[i - 1].activityCatogory;
                          let formattedDate;
                          if (
                            index.activityCatogory == 'Today' ||
                            index.activityCatogory == 'Tomorrow' ||
                            index.activityCatogory == 'Yesterday'
                          ) {
                            formattedDate = index.activityCatogory;
                          } else {
                            formattedDate = moment(
                              index.activityCatogory
                            ).format('DD-MM-YYYY');
                          }

                          return (
                            <Box>
                              <React.Fragment key={index.activityId}>
                                {isNewCategory && (
                                  <>
                                    <TimelineItem key={index.activityId}>
                                      <TimelineSeparator sx={{ pl: '3px' }}>
                                        <Typography sx={circleCont}>
                                          <Calendarimg width={20} height={20} />
                                        </Typography>

                                        <>
                                          <TimelineConnector
                                            sx={{
                                              bgcolor: 'transparent',
                                              borderLeft:
                                                '1.5px dashed #AF05FF',
                                              minHeight: '65px',
                                            }}
                                          />
                                        </>
                                      </TimelineSeparator>
                                      <TimelineContent
                                        sx={{ marginTop: '-8px' }}
                                      >
                                        <Typography
                                          sx={{
                                            ...poppins300,
                                            fontSize: '12px',
                                            color: '#000000',
                                          }}
                                        >
                                          {formattedDate}
                                        </Typography>
                                      </TimelineContent>
                                    </TimelineItem>
                                  </>
                                )}
                                <TimelineItem key={index.activityId}>
                                  <TimelineSeparator sx={{ pl: '3px' }}>
                                    <Typography sx={circleCont}>
                                      {index?.activityType?.includes(
                                        'Campaign'
                                      ) ? (
                                        <Campaignicon width={12} height={12} />
                                      ) : index?.activityType?.includes(
                                          'Deposit'
                                        ) ? (
                                        <Depositicon width={12} height={12} />
                                      ) : index?.activityType?.includes(
                                          'Offer'
                                        ) ? (
                                        <Offericon width={12} height={12} />
                                      ) : index?.activityType?.includes(
                                          'Contract'
                                        ) ? (
                                        <Contractmanagement
                                          width={12}
                                          height={12}
                                        />
                                      ) : index?.activityType?.includes(
                                          'Due'
                                        ) ? (
                                        <Duediligence width={12} height={12} />
                                      ) : index?.activityType?.includes(
                                          '66W'
                                        ) ? (
                                        <Request66w width={12} height={12} />
                                      ) : index?.activityType?.includes(
                                          'Inspection'
                                        ) ? (
                                        <Inspectionicon
                                          width={12}
                                          height={12}
                                        />
                                      ) : index?.activityType?.includes(
                                          'Solicitor'
                                        ) ? (
                                        <Solicitoricon width={12} height={12} />
                                      ) : index?.activityType?.includes(
                                          'Personal'
                                        ) ? (
                                        <Personalprofileicon
                                          width={12}
                                          height={12}
                                        />
                                      ) : (
                                        <Eye width={20} height={20} />
                                      )}
                                    </Typography>

                                    {i < arr?.length - 1 ? (
                                      <>
                                        <TimelineConnector
                                          sx={{
                                            bgcolor: 'transparent',
                                            borderLeft: '1.5px dashed #AF05FF',
                                            minHeight: '65px',
                                          }}
                                        />
                                      </>
                                    ) : null}
                                  </TimelineSeparator>

                                  <TimelineContent
                                    sx={{
                                      marginTop: '-20px',
                                      padding: '0px',
                                      paddingLeft: '10px',
                                    }}
                                  >
                                    <ActivityCard
                                      index={index}
                                      onPropertyClick={onPropertyClick}
                                      primaryUserTypeValue={
                                        primaryUserTypeValue
                                      }
                                      variant="timeline"
                                    />
                                  </TimelineContent>
                                </TimelineItem>
                              </React.Fragment>
                            </Box>
                          );
                        })
                      : null
                    : activitydata?.length > 0
                    ? activitydata.map((index, i, arr) => {
                        const isNewCategory =
                          i === 0 ||
                          index.activityCatogory !==
                            arr[i - 1].activityCatogory;
                        let formattedDate;
                        if (
                          index.activityCatogory == 'Today' ||
                          index.activityCatogory == 'Tomorrow' ||
                          index.activityCatogory == 'Yesterday'
                        ) {
                          formattedDate = index.activityCatogory;
                        } else {
                          formattedDate = moment(index.activityCatogory).format(
                            'DD-MM-YYYY'
                          );
                        }

                        return (
                          <React.Fragment key={index.activityId}>
                            {isNewCategory && (
                              <>
                                <TimelineItem key={index.activityId}>
                                  <TimelineSeparator sx={{ pl: '3px' }}>
                                    <Typography sx={circleCont}>
                                      <Calendarimg width={20} height={20} />
                                    </Typography>
                                    <>
                                      <TimelineConnector
                                        sx={{
                                          bgcolor: 'transparent',
                                          borderLeft: '1.5px dashed #AF05FF',
                                          minHeight: '65px',
                                        }}
                                      />
                                    </>
                                  </TimelineSeparator>
                                  <TimelineContent sx={{ marginTop: '-8px' }}>
                                    <Typography
                                      sx={{
                                        ...poppins300,
                                        fontSize: '12px',
                                        color: '#000000',
                                      }}
                                    >
                                      {formattedDate}
                                    </Typography>
                                  </TimelineContent>
                                </TimelineItem>
                              </>
                            )}
                            <TimelineItem key={index.activityId}>
                              <TimelineSeparator sx={{ pl: '3px' }}>
                                <Typography sx={circleCont}>
                                  {index?.activityType?.includes('Campaign') ? (
                                    <Campaignicon width={12} height={12} />
                                  ) : index?.activityType?.includes(
                                      'Deposit'
                                    ) ? (
                                    <Depositicon width={12} height={12} />
                                  ) : index?.activityType?.includes('Offer') ? (
                                    <Offericon width={12} height={12} />
                                  ) : index?.activityType?.includes(
                                      'Contract'
                                    ) ? (
                                    <Contractmanagement
                                      width={12}
                                      height={12}
                                    />
                                  ) : index?.activityType?.includes('Due') ? (
                                    <Duediligence width={12} height={12} />
                                  ) : index?.activityType?.includes('66W') ? (
                                    <Request66w width={12} height={12} />
                                  ) : index?.activityType?.includes(
                                      'Inspection'
                                    ) ? (
                                    <Inspectionicon width={12} height={12} />
                                  ) : index?.activityType?.includes(
                                      'Solicitor'
                                    ) ? (
                                    <Solicitoricon width={12} height={12} />
                                  ) : index?.activityType?.includes(
                                      'Personal'
                                    ) ? (
                                    <Personalprofileicon
                                      width={12}
                                      height={12}
                                    />
                                  ) : (
                                    <Eye width={20} height={20} />
                                  )}
                                </Typography>
                                {i < arr?.length - 1 ? (
                                  <>
                                    <TimelineConnector
                                      sx={{
                                        bgcolor: 'transparent',
                                        borderLeft: '1.5px dashed #AF05FF',
                                        minHeight: '65px',
                                      }}
                                    />
                                  </>
                                ) : null}
                              </TimelineSeparator>

                              <TimelineContent
                                sx={{
                                  marginTop: '-20px',
                                  padding: '0px',
                                  paddingLeft: '10px',
                                }}
                              >
                                <ActivityCard
                                  index={index}
                                  onPropertyClick={onPropertyClick}
                                  primaryUserTypeValue={primaryUserTypeValue}
                                />
                              </TimelineContent>
                            </TimelineItem>
                          </React.Fragment>
                        );
                      })
                    : null}
                </Timeline>
              )}
            </Grid>
          )}
        </Box>
      </Typography>
    </Card>
  );
}

export default ActivityContainer;
